import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WithDefaultPipe } from './with-default.pipe';
import { NumberMaskPipe } from './number-mask.pipe';
import { FlagPipe } from './flag.pipe';
import { LoanPeriodTypePipe } from './loan-period-type.pipe';
import { ShortDatePipe } from './short-date.pipe';
import { CamelCaseToTitleCasePipe} from './camel-case-to-title-case.pipe'

@NgModule({
  declarations: [NumberMaskPipe, FlagPipe, LoanPeriodTypePipe],
  imports: [CommonModule, WithDefaultPipe, ShortDatePipe, CamelCaseToTitleCasePipe],
  exports: [WithDefaultPipe, NumberMaskPipe, FlagPipe, LoanPeriodTypePipe, ShortDatePipe, CamelCaseToTitleCasePipe]
})
export class SharedPipesModule {}
